// extracted by mini-css-extract-plugin
export default {"label":"eoozy","container":"i8rne"};